export const nonBookingGolfClubSegments = [
  'golfhaftet',
  'confirm',
  'confirmed',
  'pay',
  'cancel',
  'accommodation'
];
